export default __webpack_public_path__ + "static/media/down.43ec6c43.svg";